import { useIsFetching, useIsMutating } from "@tanstack/react-query";

export function useLoading() {
  const isFetching = useIsFetching();
  const isMutating = useIsMutating();
  const isLoading = isFetching > 0 || isMutating > 0;

  return { isLoading };
}
